import "highlight.js";
import CodeEditor from "simple-code-editor";

const languageMap = {
  js: "javascript",
  json: "json",
  html: "html",
  bash: "bash",
  swift: "swift",
  kotlin: "kotlin",
  brightscript: "javascript",
  js_third_party: "javascript",
  css: "css",
};

const props = {
  header: false,
  width: "100%",
  lineNums: true,
  theme: "stackoverflow-light",
  fontSize: "0.9rem",
  class: "editor-wrapper",
  languages: [["javascript"]],
};

export const useCodeEditor = () => {
  const languages = lang => {
    const mappedLanguage = languageMap[lang] || "javascript";
    return [[mappedLanguage]];
  };

  return { CodeEditor, props, languages };
};
